import { useState } from "react";
import { toast } from "sonner";
import { BadgePercent } from "lucide-react";
import { api } from "@/lib/api";

export const OfferCapture = ({ source = "shop" }) => {
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [expires, setExpires] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/shop/offer", { email, source, website });
      localStorage.setItem("nrc_offer_claimed", "1");
      if (r.data.expires_at) setExpires(r.data.expires_at);
      toast.success(r.data.message || "Sent. Check your inbox.");
      setDone(true);
    } catch {
      toast.error("Something broke. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="offer-capture" className="border border-white/15 p-8 lg:p-12 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
      <div>
        <div className="flex items-center gap-3">
          <BadgePercent size={22} className="text-white/60" />
          <p className="font-mono-label text-white/40">NO DEAD ENDS</p>
        </div>
        <h3 className="font-display text-2xl lg:text-4xl mt-4">DIDN'T FIND WHAT YOU WERE LOOKING FOR?</h3>
        <p className="text-white/50 text-sm mt-3 max-w-md">
          Drop your email and we'll send you <span className="text-white font-semibold">25% OFF any piece of merch</span> — every tee, hat, and city drop in the shop. Code expires in 7 days, no minimum.
        </p>
      </div>
      {done ? (
        <div data-testid="offer-success" className="border border-white/25 p-6">
          <p className="font-mono-label text-white/80">✓ CODE SENT. CHECK YOUR INBOX.</p>
          <p className="text-white/50 text-sm mt-3">
            Enter it at checkout on any piece in the shop.
            {expires && (
              <span className="block mt-1 text-white/70" data-testid="offer-expiry-line">
                It expires {new Date(expires).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" }).toUpperCase()} — 7 days from now.
              </span>
            )}
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3" data-testid="offer-form">
          <input
            type="text"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
            tabIndex="-1"
            autoComplete="off"
            aria-hidden="true"
            className="hidden"
          />
          <input
            data-testid="offer-email-input"
            type="email"
            required
            placeholder="EMAIL ADDRESS"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 bg-transparent border-b border-white/30 py-3 text-sm placeholder:text-white/30 focus:border-white transition-colors duration-200"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="offer-submit"
            className="btn-invert font-mono-label bg-white text-ink border border-white px-6 py-3.5 hover:bg-transparent hover:text-white disabled:opacity-50 shrink-0"
          >
            {loading ? "SENDING..." : "SEND MY 25% OFF"}
          </button>
        </form>
      )}
    </div>
  );
};
